<template>
  <div class="flex w-full flex-col divide-y">
    <div v-for="log in logs" :key="log.id">
      <template v-if="log.data">
        <note-item
          v-if="isNoteLog(log)"
          :id="log.id"
          :item="log.data"
          :editing-note="false"
          class="transition-colors duration-500 ease-in-out"
          @note:deleted="emit('note:deleted')"
          @note:pin-changed="emit('note:pin-changed')"
        />
        <sms-item
          v-else-if="isSmsLog(log)"
          :id="log.id"
          :item="log.data"
          data-cy="sms-item"
        />
        <call-item
          v-else-if="isCallLog(log)"
          :id="log.id"
          :item="log.data"
          data-cy="call-item"
        />
        <task-item v-else-if="isTaskLog(log)" :item="log" data-cy="task-item" />
        <email-item
          v-else-if="isEmailLog(log)"
          :item="log.data"
          data-cy="email-item"
          @thread:open="emit('thread:open', log)"
        />
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import {
  isCallLog,
  isEmailLog,
  isNoteLog,
  isSmsLog,
  isTaskLog,
} from "@/helpers/communication";

import CallItem from "@/components/deals/dealActivity/call/CallItem.vue";
import EmailItem from "@/components/deals/dealActivity/emails/EmailItem.vue";
import NoteItem from "@/components/deals/dealActivity/notes/NoteItem.vue";
import SmsItem from "@/components/deals/dealActivity/sms/SmsItem.vue";
import TaskItem from "@/components/deals/dealActivity/tasks/TaskItem.vue";

import type {
  CommunicationLogBase,
  EmailLog,
} from "@/models/communicationLogs";

const { logs } = defineProps<{ logs: CommunicationLogBase[] }>();

const emit = defineEmits<{
  "note:deleted": [];
  "note:pin-changed": [];
  "thread:open": [log: EmailLog];
}>();
</script>
